import APIUrl from "../../APIUrl";
import axios from "axios";
import Util from "../../util/Util";

export const GET_USER = "GET_USER";

export function getUserAction(user) {
  return { type: GET_USER, user: user };
}

export const getUser = function (callback) {
  return function (dispatch) {
    return axios
      .get(APIUrl.getUser)
      .then(function (response) {
        if (!response || !response.status)
          window.location.replace(Util.getLogoutUrl());

        dispatch(getUserAction(response.data));
        if (callback) callback();
      })
      .catch(function (err) {
        window.location.replace(Util.getLogoutUrl());
      });
  };
};

export const checkIfUsernameExists = function (
  username,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfUsernameExists + username)
      .then(function (response) {
        if (response && response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const checkIfEmailExists = function (
  email,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfEmailExists + email)
      .then(function (response) {
        if (response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const updateUser = function (data, successCallback) {
  return function (dispatch) {
    return axios.post(APIUrl.updateUser, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};
